import React, { useEffect, useState } from "react";

import "./ProjectsStyles.css";

// Animations
import { TypeAnimation } from "react-type-animation";
import { Fade } from "react-reveal";

// Custom Components

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ProjectContainer from "../components/ProjectContainer";

const nothing = 0;
const professional = 1;
const major = 2;
const minor = 3;

const websiteImageArrayInterval = 5000;


export default function Projects() {
    // Size Handling for Type Animation Re-renders
    React.useEffect(() => {
        document.title = "Projects | Stone Culver";
    })

    const [width, setWidth] = useState(window.innerWidth);

    // add this useEffect hook
    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [selected, setSelected] = useState(nothing);

    // Hovered States
    const [professionalIsHovered, setProfessionalIsHovered] = useState(false);
    const [majorIsHovered, setMajorIsHovered] = useState(false);
    const [minorIsHovered, setMinorIsHovered] = useState(false);

    // Show More States

    const [hugsShowMore, setHugsShowMore] = useState(false);
    const [mrWoofShowMore, setMrWoofShowMore] = useState(false);
    const [trijiconShowMore, setTrijiconShowMore] = useState(false);
    const [motherhoardShowMore, setMotherhoardShowMore] = useState(false);

    // Image Arrays

    const hugsHomePageImages = ["images/ProjectImages/HugsShowMore/hugs-homepage-1.png", "images/ProjectImages/HugsShowMore/hugs-homepage-2.png",
        "images/ProjectImages/HugsShowMore/hugs-homepage-3.png",
    ];

    const hugsApplicationPageImages = ["images/ProjectImages/HugsShowMore/hugs-apply-1.png", "images/ProjectImages/HugsShowMore/hugs-apply-2.png",
        "images/ProjectImages/HugsShowMore/hugs-apply-3.png",
    ];

    const hugsEmployeeDashboardImages = ["images/ProjectImages/HugsShowMore/hugs-employee-dashboard-1.png", "images/ProjectImages/HugsShowMore/hugs-employee-dashboard-2.png",
        "images/ProjectImages/HugsShowMore/hugs-employee-dashboard-3.png"
    ];

    const hugsMiscPagesImages = ["images/ProjectImages/HugsShowMore/hugs-misc-pages-1.png", "images/ProjectImages/HugsShowMore/hugs-misc-pages-2.png", "images/ProjectImages/HugsShowMore/hugs-misc-pages-3.png",
        "images/ProjectImages/HugsShowMore/hugs-misc-pages-4.png", "images/ProjectImages/HugsShowMore/hugs-misc-pages-5.png",
    ];

    // src indexes

    const [hugsHomePageImagesIndex, setHugsHomePageImagesIndex] = useState(0);
    const [hugsApplicationPageImagesIndex, setHugsApplicationPageImagesIndex] = useState(0);
    const [hugsEmployeeDashboardImagesIndex, setHugsEmployeeDashboardImagesIndex] = useState(0);
    const [hugsMiscPagesImagesIndex, setHugsMiscPagesImagesIndex] = useState(0);

    const [opacity, setOpacity] = useState(1);

    useEffect(() => {
        if (hugsShowMore) {
            const intervalIds = [];
            const timeouts = [];

            const fadeSequence = (setIndexFn, imageArray) => {
                setOpacity(0); // Start fading out
                setTimeout(() => {
                    setIndexFn((prevIndex) => (prevIndex + 1) % imageArray.length);
                    setOpacity(1); // Start fading in
                }, websiteImageArrayInterval);
            };

            // Helper to stagger intervals
            const startStaggeredInterval = (delay, callback) => {
                const timeoutId = setTimeout(() => {
                    callback(); // run immediately once
                    const intervalId = setInterval(callback, websiteImageArrayInterval);
                    intervalIds.push(intervalId);
                }, delay);
                timeouts.push(timeoutId);
            };

            startStaggeredInterval(0, () => fadeSequence(setHugsHomePageImagesIndex, hugsHomePageImages));
            startStaggeredInterval(1000, () => fadeSequence(setHugsApplicationPageImagesIndex, hugsApplicationPageImages));
            startStaggeredInterval(2000, () => fadeSequence(setHugsEmployeeDashboardImagesIndex, hugsEmployeeDashboardImages));
            startStaggeredInterval(3000, () => fadeSequence(setHugsMiscPagesImagesIndex, hugsMiscPagesImages));

            return () => {
                intervalIds.forEach(clearInterval);
                timeouts.forEach(clearTimeout);
            };
        }
    }, [hugsShowMore]);




    const renderHugsShowMore = () => {
        if (hugsShowMore) {
            return (
                <>
                    <div className="project-description-container view-more-container">
                        <div className="project-description-image-container">
                            <img className="project-description-image" src={hugsHomePageImages[hugsHomePageImagesIndex]}
                                alt="Hearts unite to give support homepage" />
                        </div>

                        <div className="project-description-text align-right margin-left">
                            <p>When designing the HUGS homepage, I wanted to give a professional but welcoming feel. Ultimately, I accomplished this by using a subtle blue in contrast with a striking red to help tie in the feelings of professionalism with the attitude of helping those in need.</p>
                            <p>Homepages can say a lot about your brand, and for me it was important that people knew what HUGS was set out to do and who they were first. Continuing down the page, there's images of people at events, statistics on how much assistance they've given, and more!</p>
                            <p>If you're interested in seeing how the homepage looks today, click the image on your left!</p>
                        </div>
                    </div>

                    <div className="project-description-container view-more-container">
                        <div className="project-description-text align-left margin-right">
                            <p>The next most important thing was to make sure that users who are in need of help have a quick and easy way to apply for assistance, helping guide them along the way to make the process as quick and easy as possible.</p>
                            <p>I tried my best to make sure that the user experience was clear, concise, and left little room for error. Part of the way I was able to accomplish that was by using React and React useStates to make everything update in real time and show the user exactly what is missing and where. The application page also features interactive menus that update in real time based on responses, for instance, if a user applying is underaged they will be met with a section that then asks them for their guardians information.</p>
                            <p>It's never easy to satisfy everyone, but I'm proud to say that the application system very rarely ever gets complaints. Even amongst the elderly and less technology-inclined users of the website, the consensus is that it is quick, helpful, and easy to use!</p>
                        </div>

                        <div className="project-description-image-container">
                            <img className="project-description-image" src={hugsApplicationPageImages[hugsApplicationPageImagesIndex]}
                                alt="Hearts unite to give support application page" />
                        </div>
                    </div>

                    <div className="project-description-container view-more-container">
                        <div className="project-description-image-container">
                            <img className="project-description-image" src={hugsEmployeeDashboardImages[hugsEmployeeDashboardImagesIndex]}
                                alt="Hearts unite to give support employee dashboard" />
                        </div>

                        <div className="project-description-text align-right margin-left">
                            <p>The main feature of the website is the interactivity that the employees have when using it. The initial development process was around 4-5 months to get everything in place, and during my time as a full time employee I was able to spend years refining and adding functionality, largely aimed at the employees ability to interact with their database and users.</p>
                            <p>For example, employees have the ability to respond to applications, email the applicants directly through the website, query for specific application categories, search for specific applications and more!</p>
                            <p>Beyond that, I implemented a system where the employees themselves could post events and notify users without any extra coding necessary on my end through clever use of React components and giving the staff members the ability to directly upload the information to the website using their dashboard.</p>
                        </div>
                    </div>

                    <div className="project-description-container view-more-container">
                        <div className="project-description-text align-left margin-right">
                            <p>Ultimately development of this project has been a multi-year effort and going over every single detail would be too cumbersome for the purposes of this website.</p>
                            <p>However, here's some notable features of the website I haven't yet mentioned: A fully custom API layer with extensive and detailed action and error logging, detailed statistics of all user, application, event, and finanical data, ability to customize user roles and permissions through the employee dashboard UI (ex. limit certain employees to viewing certain things), a fully featured report system, the ability to view users by region, a fully custom token system for searching for and identifying user applications, and more!</p>
                            <p>While a project of its nature is never truly a finished project, I'm extremely happy with the progress its made and what I was able to accomplish alongside HUGS working as the sole fullstack developer.</p>
                        </div>

                        <div className="project-description-image-container">
                            <img className="project-description-image" src={hugsMiscPagesImages[hugsMiscPagesImagesIndex]}
                                alt="Hearts unite to give support homepage" />
                        </div>
                    </div>

                </>
            )
        }
    }

    const renderMotherhoardShowMore = () => {
        if (motherhoardShowMore) {
            return (
                <>
                    <div className="project-description-container">
                        <div className="project-description-image-container">
                            <img className="project-description-image" src={'/images/ProjectImages/MotherhoardShowMore/motherhoard.gif'}
                                alt="Hearts unite to give support homepage" />
                        </div>

                        <div className="project-description-text align-right margin-left">
                            <p>This project stands as one that "got away" for me, as I had really ambitious plans on how to expand out their website and business which ultimately weren't able to come to fruition.</p>
                            <p>One of the things I'm most proud of was integrating the branding materials they gave me into the background. I converted some of the stickers they include complimentary in their products into a SVG format and used a React library to animate it using tuned randomized interval values to help make the experience of visiting the website pop.</p>
                            <p>Additionally, I added some of the functionality to connect the front-end I was using to Shopify. However, as the project had to be scrapped the product page never got to be fully realised. Still, I'm proud of the design work I was able to do for them and hope to one day work again with them.</p>
                        </div>
                    </div>
                </>
            )
        }
    }

    const renderSelection = () => {
        switch (selected) {
            case (nothing): {
                return (
                    <>
                        <div className="nothing-selected">
                            <div className="nothing-selected-helper-text-container">
                                <TypeAnimation
                                    sequence={[
                                        '', 300, 'Click Above to Get Started!', 1500
                                    ]}
                                    speed={50}
                                    cursor={false}
                                    className="projects-nothing-type-animation"
                                />
                            </div>
                            <img className="stone-thinking-image" src='/images/thinking-stone.png' />
                        </div>
                    </>
                )
            }

            case (professional): {
                return (
                    <>
                        <div className="professional-projects-container container-shadow">
                            <TypeAnimation
                                key={'My Professional Projects'}
                                sequence={[
                                    '', 300, 'My Professional Projects', 1500
                                ]}
                                speed={50}
                                cursor={false}
                                className="projects-section-type-animation" />
                            <Fade delay={800}>


                                <ProjectContainer title={"Hearts Unite to Give Support"}
                                    titleColorClass={"hugs-title"}
                                    date={"2021-Present"}
                                    languages={"React, NodeJS, Express, MongoDB, Mailchimp, Constant Contact, Mailgun, AWS, bcrypt, md5"}
                                    description={"What began as freelance work with HUGS has evolved into a full-time development project with an expanding feature set tailored to evolving user needs and feature requests. The platform includes a comprehensive application system that allows users to apply for financial assistance, view events, and more. Authorized staff, using a custom-built security system, can manage applications, create and modify events, handle user reports, configure employee permissions, and perform other administrative tasks as needed. Through my website, over $100,000 worth of finanical assistance has been given to those in need as well as expanding their contact network and user base into the hundreds."}
                                    showMore={hugsShowMore}
                                    setShowMore={setHugsShowMore}
                                    viewMore={true}
                                    canView={true}
                                    isWebsite={true}
                                    logoSrc={"/images/hugs-logo.png"}
                                    logoAlt={"hearts unite to give support logo"}
                                    projectImage={false}
                                    projectHref={'https://hearts-unite.com'}
                                />

                            </Fade>

                            {renderHugsShowMore()}

                            <Fade delay={300}>
                                <ProjectContainer title={"Tilda Oü"}
                                    titleColorClass={"tilda-title"}
                                    date={"2025-Present"}
                                    languages={"NextJS, Zone"}
                                    description={"Tilda Tattuu is a tatoo artist based out of Tartu, Estonia which I collaborated with to design and maintain a portfolio website for in 2025. We worked closely together to create a unique and interesting design which stands out among the crowd."}
                                    showMore={mrWoofShowMore}
                                    setShowMore={setMrWoofShowMore}
                                    viewMore={false}
                                    canView={true}
                                    isWebsite={true}
                                    logoSrc={"/images/tilda-logo.png"}
                                    logoAlt={"tilda tattuu logo"}
                                    projectImage={false}
                                    projectHref={'https://tilda-tattuu.ee/'}
                                />
                            </Fade>

                            <Fade delay={300}>
                                <ProjectContainer title={"Mr.Woof Oy"}
                                    titleColorClass={"mrwoof-title"}
                                    date={"2024-Present"}
                                    languages={"NextJS, AWS"}
                                    description={"Mr.Woof Oy is a pet care and grooming company based out of Lahti, Finland which I had the pleasure of working with to create a more robust and feature rich website using their existing branding and styles as a basis. The website contains both Finnish and English versions, as well as a search function for users looking to get pricing in real time based on their dog breed and needs. The website is still in use today and has had no major issues since launch!"}
                                    showMore={mrWoofShowMore}
                                    setShowMore={setMrWoofShowMore}
                                    viewMore={false}
                                    canView={true}
                                    isWebsite={true}
                                    logoSrc={"/images/mrwoof-logo.png"}
                                    logoAlt={"mr woof logo"}
                                    projectImage={false}
                                    projectHref={'https://trimmaus.com'}
                                />
                            </Fade>

                            <Fade delay={300}>
                                <ProjectContainer title={"Motherhoard Controllers"}
                                    titleColorClass={"motherhoard-title"}
                                    date={"2024"}
                                    languages={"NextJS, Shopify"}
                                    description={"Motherhoard controllers is an American hobby business which I worked for freelance in 2024. Ultimately we were unable to finalize the product due to financial constraints. However, a large portion of the work was done in exchange for money so I am including it in my professional projects."}
                                    showMore={motherhoardShowMore}
                                    setShowMore={setMotherhoardShowMore}
                                    viewMore={true}
                                    canView={false}
                                    isWebsite={true}
                                    logoSrc={"/images/motherhoard-logo.png"}
                                    logoAlt={"motherhoard logo"}
                                    projectImage={false}
                                    projectHref={''}
                                />
                            </Fade>

                            {renderMotherhoardShowMore()}

                            <Fade delay={300}>
                                <ProjectContainer title={"Trijicon"}
                                    titleColorClass={"trijicon-title"}
                                    date={"2023"}
                                    languages={"C++"}
                                    description={"In 2023 I did sub-contract work for an employee of Trijicon to develop a tool to compare changes between CAD .dat files to descern where possible user error in changing settings had occured."}
                                    showMore={trijiconShowMore}
                                    setShowMore={setTrijiconShowMore}
                                    viewMore={false}
                                    canView={true}
                                    isWebsite={false}
                                    logoSrc={"/images/trijicon-logo.png"}
                                    logoAlt={"trijicon logo"}
                                    projectImage={false}
                                    projectHref={'https://github.com/duskuser/file-comparison-tool'}
                                />
                            </Fade>
                        </div>

                    </>
                )
            }

            case (major): {
                return (
                    <div className="professional-projects-container container-shadow">
                        <TypeAnimation
                            key={'Some Big Hobby Projects'}
                            sequence={[
                                '', 300, 'Some Big Hobby Projects', 1500
                            ]}
                            speed={50}
                            cursor={false}
                            className="projects-section-type-animation" />
                        <Fade delay={300}>
                            <ProjectContainer title={"Personal Website (2025)"}
                                titleColorClass={"major-project-title"}
                                date={"2025"}
                                languages={"React, AWS"}
                                description={"What you're currently viewing is my revamped 2025 personal website! Every few years I redo my personal website to make it more reflective of where my current skillset and design interests are!"}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={true}
                                isWebsite={true}
                                logoSrc={"/images/ProjectImages/stoneculver-website-2025.png"}
                                logoAlt={"stone culver 2025 website"}
                                projectImage={true}
                                projectHref={'https://hearts-unite.com'}
                            />

                        </Fade>

                        <Fade delay={300}>
                            <ProjectContainer title={"Personal Website (2023)"}
                                titleColorClass={"major-project-title"}
                                date={"2023-2024"}
                                languages={"React, AWS"}
                                description={"This was the previous iteration of my website developed in 2023 to reflect my work history and skills at the time. While there were aspects about this design that I like to this day, I am glad to have moved on from it to what you're currently viewing."}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={false}
                                isWebsite={true}
                                logoSrc={"/images/ProjectImages/stoneculver-website-2023.png"}
                                logoAlt={"stone culver 2023 website"}
                                projectImage={true}
                                projectHref={''}
                            />
                        </Fade>


                        <Fade delay={300}>
                            <ProjectContainer title={"Personal Website (2022)"}
                                titleColorClass={"major-project-title"}
                                date={"2022-2023"}
                                languages={"React, Github Pages"}
                                description={"This was the first iteration of my personal website, which was at the time hosted using github-pages instead of AWS. Ultimately the website is functional, however I believe that my design principles and understanding of how to direct a users attention have improved significantly since making this website."}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={false}
                                isWebsite={true}
                                logoSrc={"/images/ProjectImages/stoneculver-website-2022.png"}
                                logoAlt={"stone culver 2022 website"}
                                projectImage={true}
                                projectHref={''}
                            />
                        </Fade>

                        <Fade delay={300}>
                            <ProjectContainer title={"Sudoku App"}
                                titleColorClass={"major-project-title"}
                                date={"2023"}
                                languages={"React Native"}
                                description={"In 2023 I developed a Sudoku app for android devices as a way to learn React Native and become more familiar with mobile development. Features included scaling difficulty levels and fully customizable difficulty levels, unlockable level themes, streaks, endless mode, and more."}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={false}
                                isWebsite={true}
                                logoSrc={"/images/ProjectImages/sudoku-app.png"}
                                logoAlt={"sudoku app"}
                                longImage={true}
                                projectImage={true}
                                projectHref={''}
                            />
                        </Fade>

                        <Fade delay={300}>
                            <ProjectContainer title={"'DIY' Chess Engine"}
                                titleColorClass={"major-project-title"}
                                date={"2022"}
                                languages={"C++"}
                                description={"In 2022 I developed my own chess engine using the C++ knowledge I had gathered during that time. I put extra emphasis on trying to do everything as manually and efficiently as possible to reflect my skillset at the time in the programming language. Unfortunately, the full project code has been lost due to an error in formatting on my part. However, there is an archive of this project which remains to this day. Though the backup is missing the engine itself, it still shows some of the design priniciples I was instituting and is relatively reflective of the final gameboard representation in memory that the project was using."}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={true}
                                isWebsite={false}
                                logoSrc={"/images/ProjectImages/chess-engine.png"}
                                logoAlt={"diy chess engine"}
                                projectImage={true}
                                projectHref={'https://github.com/duskuser/chess-project-archive'}
                            />
                        </Fade>

                        <Fade delay={300}>
                            <ProjectContainer title={"Full-Stack ChatApp"}
                                titleColorClass={"major-project-title"}
                                date={"2022"}
                                languages={"C#, WPF, SQLite"}
                                description={"In 2022 I embarked on developing my first full stack project by using C# and WPF to create an interactive IRC-esque chat app. Ultimately I feel the project is reflective of my newbie skill level at the time. However in spite of that, ultimately the functionality to log in, message other users, see how many users are online, and more were added before the project was finished."}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={false}
                                isWebsite={false}
                                logoSrc={"/images/ProjectImages/chat-app.png"}
                                logoAlt={"full stack chat app"}
                                projectImage={true}
                                projectHref={''}
                            />
                        </Fade>

                        <Fade delay={300}>
                            <ProjectContainer title={"Singleplayer Chess"}
                                titleColorClass={"major-project-title"}
                                date={"2021"}
                                languages={"Python / Pygame"}
                                description={"One of my first completed programming projects in 2021 was creating a singleplayer chess game using Python and Pygame. This program served as one of my first serious forays into OOP as well as managing both the front-end and back-end of a project. The project itself is not that challenging for an experienced developer, however as it was my first project I completed from start to finish on my own, I remain proud of it to this day (Artwork handled by me)."}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={false}
                                isWebsite={false}
                                logoSrc={"/images/ProjectImages/python-chess.png"}
                                logoAlt={"singe player chess app"}
                                projectImage={true}
                                projectHref={''}
                            />
                        </Fade>
                    </div>
                )
            }

            case (minor): {
                return (
                    <div className="professional-projects-container container-shadow">
                        <TypeAnimation
                            key={'Smaller Hobby Projects'}
                            sequence={[
                                '', 300, 'Smaller Hobby Projects', 1500
                            ]}
                            speed={50}
                            cursor={false}
                            className="projects-section-type-animation" />
                        <Fade delay={300}>
                            <ProjectContainer title={"SSBM Algo"}
                                titleColorClass={"minor-project-title"}
                                date={"2025"}
                                languages={"NextJS"}
                                description={"SSBM Algo is a system to descern players rankings in the game SSBM throughout a year which I developed for fun alongside ideas from some friends. Right now the project is private and unfinished beyond the base algorithm itself, however in the future I may finish it and make the tool (and code) public."}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={false}
                                isWebsite={false}
                                logoSrc={"/images/ProjectImages/ssbm-algo-ss.png"}
                                logoAlt={"ssbm algo screenshot"}
                                projectImage={true}
                                projectHref={''}
                            />
                        </Fade>

                        <Fade delay={300}>
                            <ProjectContainer title={"Browser Links Helper"}
                                titleColorClass={"minor-project-title"}
                                date={"2022"}
                                languages={"Python"}
                                description={"In early 2023 I wrote a script in Python to help optimize my work flow by opening a set of predetermined links as needed."}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={true}
                                isWebsite={false}
                                logoSrc={"/images/ProjectImages/browser-helper.png"}
                                logoAlt={"browser links helper"}
                                projectImage={true}
                                projectHref={''}
                            />
                        </Fade>

                        <Fade delay={300}>
                            <ProjectContainer title={"Reddit Comment Graphing Script"}
                                titleColorClass={"minor-project-title"}
                                date={"2022"}
                                languages={"Python, PRAW, Matplotlib"}
                                description={"For fun I developed an application which takes in a users Reddit data and generate graphs of the freqeuency of their word usage. It's possible for users to filter out common words and specify the number of words to graph."}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={false}
                                isWebsite={false}
                                logoSrc={"/images/ProjectImages/reddit-graphing.png"}
                                logoAlt={"reddit word graph application"}
                                projectImage={true}
                                projectHref={''}
                            />
                        </Fade>

                        <Fade delay={300}>
                            <ProjectContainer title={"Script Front End"}
                                titleColorClass={"minor-project-title"}
                                date={"2022"}
                                languages={"Python, Pygame"}
                                description={"I created a basic front-end for script starting and stopping, as well as outputting log statements to a text file using Python and Pygame to handle the front end. While using PyGame as a front-end is a bit silly on its face, the benefit to using a native Python library is that it requires very little setup!"}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={false}
                                isWebsite={false}
                                logoSrc={"/images/ProjectImages/script-front-end.png"}
                                logoAlt={"script front end program"}
                                projectImage={true}
                                projectHref={''}
                            />
                        </Fade>

                        <Fade delay={300}>
                            <ProjectContainer title={"Timer / Calculator"}
                                titleColorClass={"minor-project-title"}
                                date={"2022"}
                                languages={"C#, WPF"}
                                description={"One of my first projects to familiarize myself with C# and WPF was creating a timer and calculator. Doing this helped me get familiar with how the back-end and front-end interacted using that framework."}
                                showMore={false}
                                setShowMore={null}
                                viewMore={false}
                                canView={false}
                                isWebsite={false}
                                logoSrc={"/images/ProjectImages/timer.png"}
                                logoAlt={"timer program"}
                                projectImage={true}
                                projectHref={''}
                            />
                        </Fade>
                    </div>
                )
            }
        }
    }

    // Renders

    return (
        <>
            <div className="projects">
                <Navbar />
                <div className="project-nav">
                    <img className="project-nav-button-image"
                        src={professionalIsHovered ? '/images/professional-button-selected.png' :
                            '/images/professional-button.png'}
                        onMouseEnter={() => setProfessionalIsHovered(true)}
                        onMouseLeave={() => setProfessionalIsHovered(false)}
                        onClick={() => {
                            if (selected !== professional) {
                                setSelected(professional);
                            } else {
                                setSelected(nothing);
                            }
                        }} />

                    <img className="project-nav-button-image"
                        src={majorIsHovered ? '/images/major-button-selected.png' :
                            '/images/major-button.png'}
                        onMouseEnter={() => setMajorIsHovered(true)}
                        onMouseLeave={() => setMajorIsHovered(false)}
                        onClick={() => {
                            if (selected !== major) {
                                setSelected(major);
                            } else {
                                setSelected(nothing);
                            }
                        }} />

                    <img className="project-nav-button-image"
                        src={minorIsHovered ? '/images/minor-button-selected.png' :
                            '/images/minor-button.png'}
                        onMouseEnter={() => setMinorIsHovered(true)}
                        onMouseLeave={() => setMinorIsHovered(false)}
                        onClick={() => {
                            if (selected !== minor) {
                                setSelected(minor);
                            } else {
                                setSelected(nothing);
                            }
                        }} />
                </div>
                {renderSelection()}
                <Footer />
            </div>


        </>
    )
}